import { useContext } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import InheritanceLockIcon from '@atom/components/workTemplate/InheritanceLockIcon';
import WorkTemplateContext from '@atom/components/workTemplate/WorkTemplateContext';
import { Summary } from '@atom/types/work';
import { InheritedComponentType } from '@atom/types/workTemplate';
import { isComponentInherited } from '@atom/utilities/workTemplateUtilities';

import WorkTemplateSummaryRow from './WorkTemplateSummaryRow';

import classes from './workTemplateInfo.module.css';

const WorkTemplateSummary = () => {
  const { workTemplate } = useContext(WorkTemplateContext);

  const summary = workTemplate.summary || [];

  const isInherited = isComponentInherited(
    InheritedComponentType.SUMMARY,
    workTemplate?.inheritedComponents || [],
  );

  return (
    <>
      <div className={classes.sectionHeader}>
        <div
          className={clsx(
            classes.summaryTitle,
            isInherited && classes.disabled,
          )}
        >
          Summary
        </div>
        {isInherited && (
          <InheritanceLockIcon
            tooltip="Inherited Summary Section cannot be removed or edited."
            placement="bottom-end"
          />
        )}
      </div>
      <div className={clsx(classes.sectionContent, classes.summary)}>
        {R.isEmpty(summary) ? (
          <div className={classes.noSummary}>There is no summary.</div>
        ) : (
          summary.map((summaryItem: Summary, index: number) => (
            <WorkTemplateSummaryRow
              key={`${summaryItem.title}-${index}`}
              summary={summaryItem}
            />
          ))
        )}
      </div>
    </>
  );
};

export default WorkTemplateSummary;
